import React from 'react';
import Button from '../../../components/ui/Button';
import { ModalShell } from '../../../components/ui/ModalFrame';
import { MODAL_LAYER } from '../../../constants/modalLayers';
import { MODAL_DIALOG_ACTIONS_END } from '../../../constants/layoutSpacing';

/**
 * @param {{ open: boolean; documentTitle: string; onCancel: () => void; onConfirm: () => void | Promise<void> }} props
 */
const SignatureCancelConfirmDialog = ({
  open,
  documentTitle,
  onCancel,
  onConfirm,
}) => {
  if (!open) return null;

  const title = documentTitle?.trim() ? documentTitle.trim() : 'Sem título';

  return (
    <ModalShell
      zClass={MODAL_LAYER.standard}
      backdropClassName="bg-black/50"
      panelClassName="bg-card rounded-lg max-w-md w-full p-6 shadow-elevation-lg"
    >
      <p className="text-base text-foreground mb-6">
        Você tem certeza que deseja cancelar o envio para assinatura do documento{' '}
        <span className="font-semibold">{title}</span> ? Isso irá invalidar o
        documento que as partes receberam para assinar.
      </p>

      <div className={MODAL_DIALOG_ACTIONS_END}>
        <Button variant="outline" onClick={onCancel}>
          Cancelar
        </Button>
        <Button variant="default" onClick={onConfirm}>
          OK
        </Button>
      </div>
    </ModalShell>
  );
};

export default SignatureCancelConfirmDialog;
